export default __webpack_public_path__ + "static/media/villa.b7836077.png";